import { render, staticRenderFns } from "./DonutChart89Template.vue?vue&type=template&id=c33a8320&scoped=true"
import script from "./DonutChart89Template.vue?vue&type=script&lang=js"
export * from "./DonutChart89Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33a8320",
  null
  
)

export default component.exports